'use strict'
import {serverApi} from '@/server';

export default {

    /**
     * 获取短信验证码
     *
     * @author nick
     *
     * @method POST
     *
     * @param {string} phone 登陆手机号
     * @param {string} captcha 图形验证码
     *
     * @url /api/auth/code
     *
     * @returns {Promise}
     */
    getCode(phone,captcha){
        const url = '/auth/code'
        return serverApi.post({'phone':phone,'captcha':captcha},url);

    },

    /**
     * 登陆
     *
     * @author nick
     *
     * @method POST
     *
     * @param {string} phone 登录手机号
     * @param {string} code  手机验证码
     *
     * @url /api/auth/login
     */
    login(phone,code) {
        const url = '/auth/login'
        return serverApi.post({phone:phone,code:code},url);
    },

    /**
     * 获取用户信息
     *
     * @author nick
     *
     * @method GET
     *
     *
     * @url /auth/me
     */
    authMe() {
        const url = '/auth/me'
        return serverApi.get({},url);
    },

    /**
     * 退出
     *
     * @author nick
     *
     * @method GET
     *
     *
     * @url /auth/logout
     */
    authLogout() {
        const url = '/auth/logout'
        return serverApi.post({},url);
    },

    /**
     * 微信登录获取token
     *
     * @author nick
     *
     * @method POST
     *
     * @url /api/auth/login
     */
    getToken(){
        const url = '/wechat-token'
        return serverApi.get({},url);
      }
}
